import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {
  constructor(private http: HttpClient) {}

  getAll(id) {
    return this.http
      .post<any>(`${environment.apiUrl}/settings/module-app/module-rol`, {
        rol_id: id
      })
      .pipe(
        catchError((res: HttpErrorResponse) => {
          if (res.status === HttpStatusCode.InternalServerError) {
            return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
          }
          if (res.status === HttpStatusCode.BadRequest) {
            return throwError(() => res.error)
          }
          if (res.status === HttpStatusCode.Unauthorized) {
            return throwError(() => 'El acceso a esta solicitud no estas permitido')
          }
          return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
        }),
        map((response: any) => {
          if (response.hasOwnProperty('payload')) {
            return response.payload;
          }
          return response;
        })
      )
  }
}
